/**
 * @generated SignedSource<<11d49272643540d05658343d6d358874>>
 * @relayHash 47a9a8fe991f766b2d21dcac0ef54a1c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cfe06b3d5b20c6d7101a421841c277d54d17c626f47566864f17bfb88f39a093

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type useUpdateHideDoneMutation$variables = {
  isHideDoneEnabled: boolean;
  viewId: string;
};
export type useUpdateHideDoneMutation$data = {
  readonly jira: {
    readonly updateIssueSearchHideDonePreference: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useUpdateHideDoneMutation = {
  response: useUpdateHideDoneMutation$data;
  variables: useUpdateHideDoneMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isHideDoneEnabled"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "isHideDoneEnabled",
    "variableName": "isHideDoneEnabled"
  },
  {
    "kind": "Variable",
    "name": "viewId",
    "variableName": "viewId"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "kind": "ScalarField",
  "name": "message"
},
v5 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useUpdateHideDoneMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraIssueSearchHideDonePreferenceMutationPayload",
            "kind": "LinkedField",
            "name": "updateIssueSearchHideDonePreference",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useUpdateHideDoneMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraIssueSearchHideDonePreferenceMutationPayload",
            "kind": "LinkedField",
            "name": "updateIssueSearchHideDonePreference",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "cfe06b3d5b20c6d7101a421841c277d54d17c626f47566864f17bfb88f39a093",
    "metadata": {},
    "name": "useUpdateHideDoneMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "d5e39e06e60c261494c6de5b9d3d8d64";

export default node;
